import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { API_SERVER_URL, APP_ENV } from "../../api/network/endpoints";
import { setAppOnline, TModalsState } from "../../api/store/commonSlice";
import svgIcons from "../../assets/svg/svgIcons";
import { APP_CONFIG } from "../../constants/constants";
import VMCameraVoicecalling from "./VMCameraVoicecalling";

const PageWrapperCommonComps = () => {
  const dispatch = useDispatch();

  // modals state
  const modalsState = useSelector(
    (state: { commonReducer: { modals: TModalsState } }) =>
      state.commonReducer.modals
  );

  // keep track of online / offline network status
  const appOnline = useSelector(
    (state: { commonReducer: { appOnline: boolean } }) =>
      state.commonReducer.appOnline
  );
  const appOffline = appOnline === false;
  (window as any).appOnline = appOnline;
  const browserOnlineCallback = () => {
    if (APP_CONFIG.DEBUG.ALL) console.log("Browser is online!");
    dispatch(setAppOnline(true));
    (window as any).appOnline = true;
    // reload page once network is back online
    (window as any)?.location?.reload();
  };
  const browserOfflineCallback = () => {
    if (APP_CONFIG.DEBUG.ALL) console.log("Browser is offline!");
    dispatch(setAppOnline(false));
    (window as any).appOnline = false;
  };
  useEffect(() => {
    // Sync state with browser online status on mount.
    // This avoids stale redux value (e.g. app booted offline, user logs in after reconnect).
    const currentOnlineStatus = navigator.onLine;
    dispatch(setAppOnline(currentOnlineStatus));
    (window as any).appOnline = currentOnlineStatus;

    window.addEventListener("online", browserOnlineCallback);
    window.addEventListener("offline", browserOfflineCallback);
    return () => {
      window.removeEventListener("online", browserOnlineCallback);
      window.removeEventListener("offline", browserOfflineCallback);
    };
  }, []);

  return (
    <>
      {/* Primary Overlay */}
      {(modalsState.showPrimaryOverlay || appOffline) && (
        <div
          className={`fixed inset-0 flex flex-col gap-4 items-center justify-center bg-black/80 backdrop-blur-[1px] z-overlay-primary`}
        >
          <div className="bg-white flex items-center justify-center p-6 rounded-lg shadow-lg">
            <img
              src={svgIcons.LoadingAnimation}
              alt="Loading animation"
              className={`size-20`}
            />
          </div>
          {appOffline && (
            <div className="text-xs text-white/50 text-center">
              Waiting for network
              <br />
              Please check your internet connection
            </div>
          )}
        </div>
      )}

      {/* Cameras VisionMax Voicecalling */}
      <VMCameraVoicecalling />

      {APP_CONFIG.DEBUG.DISPLAY_VERBOSE && (
        <pre className="no-print fixed top-0 right-0 bg-amber-600 text-white z-overlay-primary text-xs px-2">{`[${APP_ENV}] ${API_SERVER_URL}`}</pre>
      )}
    </>
  );
};
export default PageWrapperCommonComps;
